import {
  makeStyles,
  createStyles,
  withStyles,
  Theme,
} from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 35,
      borderRadius: 20,
    },
    colorPrimary: {
      backgroundColor: "rgba(151, 151, 151, 1)",
    },
    bar: {
      borderRadius: 20,
      backgroundColor: "white",
    },
  })
)(LinearProgress);

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function LinearProgressBar({
  progress,
  title,
}: {
  progress: number;
  title?: string;
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box position="relative">
        <BorderLinearProgress variant="determinate" value={progress} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
            style={{
              color: "black",
              fontWeight: 700,
              fontFamily: "Gilroy-Medium, sans-serif",
              fontSize: 16,
            }}
          >
            {title || `${progress}%`}
          </Typography>
        </Box>
      </Box>
    </div>
  );
}
